// Получение списка всех контейнеров
// //api/containers/

import axios from './configAxios';

export const getAllContainersList = async (url) => {
	return axios.get(`${url}`);
};
